import { iosInstallStrings } from '../../constants/strings'
import { useIosInstallPrompt } from '../../hooks/useIosInstallPrompt'
import { DismissibleBanner } from '../DismissibleBanner'

function ShareIcon() {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 3v12" />
      <path d="M8 7l4-4 4 4" />
      <path d="M5 11v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8" />
    </svg>
  )
}

export function IosInstallBanner() {
  const { shouldShow, dismiss } = useIosInstallPrompt()

  if (!shouldShow) return null

  return (
    <DismissibleBanner
      icon={<ShareIcon />}
      title={iosInstallStrings.title}
      description={iosInstallStrings.description}
      dismissLabel={iosInstallStrings.dismissLabel}
      onDismiss={dismiss}
    >
      <ol className="mt-2 space-y-1 text-xs text-muted">
        <li className="flex items-center gap-2">
          <span className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-white text-accent">
            <ShareIcon />
          </span>
          <span>{iosInstallStrings.shareStep}</span>
        </li>
        <li className="flex items-center gap-2">
          <span className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-white text-[0.7rem] font-semibold text-accent">
            +
          </span>
          <span>{iosInstallStrings.addStep}</span>
        </li>
      </ol>
    </DismissibleBanner>
  )
}
